import { SUB_PATH_CHANNEL_MAP } from '~/url-maps/constant.mjs';
import { Channel, Content } from '@/lib/model';
import { generateChannelPath } from '@/utils';
import { normalizeChannelName } from '@/i18n/utils';

export type QueryParams = Record<string, string>;

export function getArticleLink(articleSlug: string, queryParams?: QueryParams) {
  return `/article/${articleSlug}${queryParams ? `?${new URLSearchParams(queryParams).toString()}` : ''}`;
}

export function getLiveLink(slug?: string, queryParams?: QueryParams) {
  return `/live/${slug}${queryParams ? `?${new URLSearchParams(queryParams).toString()}` : ''}`;
}

export function getVideoLink(
  videoSlug: string,
  subType?: Content['subType'],
  queryParams?: QueryParams,
) {
  const urlParams = new URLSearchParams(queryParams);
  if (subType) {
    urlParams.set('subType', subType);
  }
  return `/video/${videoSlug}${urlParams.toString() ? `?${urlParams.toString()}` : ''}`;
}

export function getAudioLink(audioSlug: string, queryParams?: QueryParams) {
  const urlParams = new URLSearchParams(queryParams);
  return `/audio/${audioSlug}${urlParams.toString() ? `?${urlParams.toString()}` : ''}`;
}

export function getTVShowLink(
  slug: string,
  contentSlug?: string,
  queryParams?: QueryParams,
) {
  if (contentSlug) {
    return `/video/tv/shows/${slug}/play/${contentSlug}${queryParams ? `?${new URLSearchParams(queryParams).toString()}` : ''}`;
  }
  return `/video/tv/shows/${slug}${queryParams ? `?${new URLSearchParams(queryParams).toString()}` : ''}`;
}

export function getChannelLink(
  link: string,
  channel: Channel,
  queryParams?: QueryParams,
) {
  const channelName = normalizeChannelName(generateChannelPath(channel));
  if (!channelName || !(channelName in SUB_PATH_CHANNEL_MAP)) {
    return link;
  }
  return `/${SUB_PATH_CHANNEL_MAP[channelName as keyof typeof SUB_PATH_CHANNEL_MAP]}${link}${queryParams ? `?${new URLSearchParams(queryParams).toString()}` : ''}`;
}
